import { Injectable } from "@angular/core"
import * as _ from 'lodash';
@Injectable({
    providedIn:'root'
})
export class LWRuleEvaluator{
    operatorMapper:any = {
        '$eq': function(a, b) {
            if (_.isArray(a)) {
                return a.indexOf(b) >= 0
            }
            return a == b
        },
        '$ne': function(a, b) { return a != b },
        '$lte': function(a, b) { return a <= b },
        '$gte': function(a, b) { return a >= b },
        '$lt': function(a, b) { return a < b },
        '$gt': function(a, b) { return a > b },
        '$and': function(a, b) { return a && b },
        '$or': function(a, b) { return a || b },
        '$has': function(a, b) { return a.indexOf(b) >= 0 },
        '$in': function(a, b) { return a in b },
        '$nin': function(a, b) {
            return !(a in b)
        }
    }
    evaluateConditions(data, condition, cb) {
        if (data && condition) {
            var leftOperand:any = {};
            var rightOperand:any = {};
            var operator_id = "";
            var result = false;
            //left operand is the data send with the event
            if (condition.hasOwnProperty('field_id')) {
                var field_id = condition.field_id.replace("__dot__", ".");
                if (field_id.indexOf('.') > 0) {
                    leftOperand = data;
                    var field_parts = field_id.split('.');
                    for (let i = 0; i < field_parts.length; i++) {
                        leftOperand = leftOperand[field_parts[i]];
                    }
                } else {
                    leftOperand = data[condition.field_id];
                }
            }

            if (condition.field_id == "tags" && condition.hasOwnProperty('field_id_value')) {
                leftOperand = leftOperand[condition.field_id_value];
                leftOperand = leftOperand.toLowerCase()
            }

            //right operand is the condition in the rule
            if (condition.hasOwnProperty('value')) {
                rightOperand = condition.value;
                if(condition.field_id == "tags"){
                    rightOperand=rightOperand.toLowerCase()
                }
            }

            if (condition.hasOwnProperty('operator_id')) {
                operator_id = condition.operator_id;
            }

            if ((leftOperand || leftOperand == 0) && rightOperand && operator_id) {
                result = this.solveExpression(leftOperand, rightOperand, operator_id);
                cb(null, result);
            } else {
                var err = "Problem occured while evaluating conditions -condition:" + JSON.stringify(condition) + "data-" + JSON.stringify(data);
                cb(err, null);
            }
        } else {
            var err = "Required Parameters not sent while evaluating condition:" + JSON.stringify(condition) + "data-" + JSON.stringify(data);
            cb(err, null);
        }
    }

    solveExpression(leftOperand, rightOperand, operator) {
        if (this.operatorMapper && this.operatorMapper[operator]) {
            var result = this.operatorMapper[operator](leftOperand, rightOperand);
            return result;
        }
    }
}